import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Events from "./pages/EventPage";
import Login from "./pages/AuthPage";
import Footer from "./components/Footer";
import Profile from "./pages/UserProfile";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminDashboard from "./pages/Admin";
import AdminRoute from "./components/AdminRoute";
import { supabase } from "./supabaseClient";

function App() {

  // ✅ Handle Supabase token passed via URL
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (token) {
      supabase.auth.setSession({
        access_token: token,
        refresh_token: token, // short-term session
      });

      // Clean the URL after setting the session
      const currentPath = window.location.pathname;
      window.history.replaceState({}, document.title, currentPath);
    }
  }, []);

  return (
    <div className="app-wrapper">
      <Router>
        {/* ✅ Always show Navbar and Footer */}
        <Navbar />

        <div className="main-content">
          <Routes>
            {/* 🌍 All public routes (accessible on both domains) */}
            <Route path="/" element={<Home />} />
            <Route path="/events" element={<Events />} />
            <Route path="/login" element={<Login />} />
            <Route path="/event/:id" element={<Events />} />

            {/* 👤 Protected user route */}
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />

            {/* 🧑‍💼 Admin dashboard (admin-only) */}
            <Route
              path="/admin"
              element={
                <AdminRoute requiredRole="admin">
                  <AdminDashboard />
                </AdminRoute>
              }
            />
          </Routes>
        </div>

        <Footer />
      </Router>
    </div>
  );
}

export default App;
